import { t } from '@lingui/macro'
import * as yup from 'yup'

export const preferencesValidationSchema = () => {
  return yup.object({
    timezone: yup.string().required(t`Timezone is a required field`),
    language: yup.string().required(t`Language is a required field`)
  })
}
